import { data_from_server_get } from '@/shared/http/client';

/**
 * Label for the default choice, sent as ``null``. Generative tasks then train
 * the model the training handler's configuration names; other tasks leave
 * ``model_name`` to the hyperparameter search.
 */
export const AUTOMATIC_BASE_MODEL_LABEL = 'Automatic';

/**
 * Human-friendly label for a HuggingFace-style id (last path segment).
 * ``Qwen/Qwen2.5-7B-Instruct`` -> ``Qwen2.5-7B-Instruct``.
 */
export function formatBaseModelLabel(modelId) {
  if (!modelId) return '';
  return String(modelId).split('/').pop();
}

const UNDECIDED_BASE_MODELS = new Set(['UNDECIDED_ENCODER', 'UNDECIDED_DECODER']);

/**
 * A training's base model id, or ``''`` while it is still an ``UNDECIDED_*``
 * placeholder (the training handler records the trained model once it picks one).
 */
export function decidedBaseModelName(modelName) {
  return modelName && !UNDECIDED_BASE_MODELS.has(modelName) ? modelName : '';
}

/** Display label for a Train -> Advanced choice, including "Automatic". */
export function formatSelectedBaseModelLabel(modelId) {
  return modelId ? formatBaseModelLabel(modelId) : AUTOMATIC_BASE_MODEL_LABEL;
}

/**
 * ``GET /base-models?task_type=...`` -> ``{ task_type, models: [{ id, label }] }``.
 *
 * The optune-utils ``base_model_catalog`` decides which models are offered.
 * Resolves to the parsed payload; rejects on network / parse failure.
 */
export async function fetchBaseModels(taskType) {
  return new Promise((resolve, reject) => {
    data_from_server_get(`base-models?task_type=${encodeURIComponent(taskType)}`, resolve).catch(reject);
  });
}
